import Swal from "sweetalert2";
import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';

export default {
    name: 'Drivers',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();
        // Drivers list — Admin (1), School owner (40), School admin (41).
        if (!this.requireUserType([1, 40, 41])) return;
        this.GetInfo(this.pageNo);
        this.GetVehicleTypes();
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        }
  ,
        hasLocation() {
            return this.selectedDriver
                && this.selectedDriver.currentLat != null
                && this.selectedDriver.currentLng != null;
        },
        googleMapsLink() {
            if (!this.hasLocation) return '#';
            const lat = this.selectedDriver.currentLat;
            const lng = this.selectedDriver.currentLng;
            return `https://www.google.com/maps?q=${lat},${lng}`;
        },
        passportSrc() {
            // عدّلي حسب نظام رفع الصور عندك (BaseUrl/Uploads...)
            // لو PassportImage عندك رابط كامل خلّيه يرجع كما هو
            const p = this.selectedDriver?.passportImage;
            if (!p) return null;

            // مثال: لو عندك مسار نسبي
            // return `${this.$BaseUrl}/Uploads/${p}`;

            return p; // لو هو URL جاهز
        },

        // Owner asked to be able to SEARCH a driver's subscriptions ("وتبحث عن
        // اشتراكات") — filter by plan name / status label / reason, client-side,
        // because a single driver never has enough rows to justify a server round-trip.
        filteredDriverSubs() {
            const all = this.driverSubs.list || [];
            const q = (this.subsSearch || '').trim().toLowerCase();
            if (!q) return all;
            return all.filter(s =>
                (s.planName || '').toLowerCase().includes(q)
                || (s.statusLabel || '').toLowerCase().includes(q)
                || (s.dropReason || '').toLowerCase().includes(q)
                || String(s.id).includes(q)
            );
        },

        // Only a super admin may end a membership (the backend enforces this too —
        // RoleScopes.IsSuperAdmin — this just hides a button that would always 4xx).
        canEndSubscription() {
            return this.loginDetails && Number(this.loginDetails.userType) === 1;
        }
    },

    data() {
        return {
            vehiclesTypes: {},
            selectedDriver: null,
            viewLoading: false,
            viewError: null,
            // Lightweight image viewer state — used when admin clicks a doc thumb.
            imageViewer: { open: false, src: '', title: '' },
            todayDate: new Date().toISOString().split('T')[0],
            driverAddStep: 'phone',
            driverPhoneLookup: { phone: '', busy: false, found: null },
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',
            DriverStatus: null,
            state:0,
            ScreenTitle: ' السائقون ',
            ScreenTitleSingle: ' سائق ',
            ScreenTitleSingleAl: 'السائق ',
            driverName: '',
            id:0,
            Info: [],
            Statistics: [],

            SelectedItem: null,
            SuspendReason: '',
            SuspendDriverId: null,

            // ---- «الاشتراك» section of the driver-detail modal (owner step
            // trip-regular-5). Kept on THIS page rather than a new screen:
            // "لا نريد اكثار الصفحات ولخبطة".
            driverSubs: {
                loading: false,
                error: null,
                hasActive: false,
                current: null,
                list: [],
                // Inline end-subscription form — the reason is MANDATORY because it
                // is what the driver is shown ("والمهم توضح للسائق سبب ... انهاء الاشتراك").
                ending: false,
                showEndForm: false,
                endReason: ''
            },
            subsSearch: '',
            ruleFormVehicle: {
                Id: null,
                DriversId: 0,
                VehiclesTypesId: null,
                Models: '',
                Years: '',
                PlateNumber: '',
                SeatsCount: null,
                InsuranceExpiry: null,
                InsuranceImage: '',
                InsuranceImageName: '',
                InsuranceCurrent: '',
                InspectionExpiry: null,
                InspectionImage: '',
                InspectionImageName: '',
                InspectionCurrent: '',
              /*  IsPrimary: false*/
            },

            vehicleRules: {
                VehiclesTypesId: this.$helper.Required(),
                Models: this.$helper.Required(),
                Years: this.$helper.Required(),
                PlateNumber: this.$helper.Required(),
                SeatsCount: this.$helper.Required()
            },
            ruleForm: {
                Id: null,
                UsersId: null,
                FirstName: '',
                FatherName: '',
                SirName: '',
                Phone: '',
                PassportExpiry: null,
                PassportImage: '',
                PassportImageName: '',
                LicenseExpiry: null,
                LicenseImage: '',
                LicenseImageName: '',
                ProfileImage: '',
                ProfileImageName: '',
                Descriptions: ''
            },
            rules: {
                FirstName: this.$helper.Required(),
                Phone: this.$helper.Required()
            }
        };
    },

    methods: {

        OpenAddDriverDialog() {
            this.ClearForm(this.ruleForm);
            this.driverAddStep = 'phone';
            this.driverPhoneLookup = { phone: '', busy: false, found: null };
        },

        LookupDriverByPhone() {
            const n = this.normalizePhone(this.driverPhoneLookup.phone);
            if (!n) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'رقم الهاتف غير صالح (مثال: 0911234567).');
                return;
            }
            this.driverPhoneLookup.busy = true;
            this.$http.SearchDriverByPhone(n)
                .then(res => {
                    this.driverPhoneLookup.busy = false;
                    const d = res.data;
                    if (d && d.found) {
                        this.driverPhoneLookup.found = d;
                        this.ruleForm.Id = d.id;
                        this.ruleForm.Phone = d.phone;
                    } else {
                        this.driverPhoneLookup.found = null;
                        this.ruleForm.Id = 0;
                        this.ruleForm.Phone = n;
                    }
                    this.driverAddStep = 'profile';
                })
                .catch(() => {
                    this.driverPhoneLookup.busy = false;
                    this.$helper.ShowMessage('error', 'خطأ', 'تعذّر البحث.');
                });
        },

        async GetVehicleTypes() {
            try {
                const res = await this.$http.GetVehicleTypes();
                this.vehiclesTypes = res.data?.info || [];
            } catch (err) {
                this.vehiclesTypes = [];
                this.$helper.ShowMessage(
                    'error',
                    'خطأ',
                    (err?.response?.data) || 'فشل جلب أنواع المركبات'
                );
            }
        },
        openAddVehicleModal() {
  
            this.selectedVehicle = null;

            this.ruleFormVehicle = {
                Id: null,
                DriversId: this.id,                 // id متاع السائق اللي انتِ فاتحته
                VehiclesTypesId: null,
                Models: '',
                Years: '',
                PlateNumber: '',
                SeatsCount: null,
                InsuranceExpiry: null,
                InspectionExpiry: null,
                IsPrimary: false
            };
        },
        openEditVehicleModal(item) {
          this.GetVehicleTypes();
            this.selectedVehicle = item;
           
            this.ruleFormVehicle = {
                Id: item.id,
                DriversId: item.driversId || this.id,
                VehiclesTypesId: item.vehiclesTypesId || null,
                Models: item.model || '',
                Years: item.year || '',
                PlateNumber: item.plateNumber || '',
                SeatsCount: item.seatsCount,
                InsuranceExpiry: item.insuranceExpiry ? this.ChangeDate(item.insuranceExpiry) : null,
                InsuranceImage: '',
                InsuranceImageName: '',
                InsuranceCurrent: item.insurance || '',
                InspectionExpiry: item.inspectionExpiry ? this.ChangeDate(item.inspectionExpiry) : null,
                InspectionImage: '',
                InspectionImageName: '',
                InspectionCurrent: item.inspection || '',
                IsPrimary: !!item.isPrimary
            };
        },

        SelectVehicleImage(event, type) {
            const file = event.target.files[0];
            if (!file) return;
            if (!file.type.startsWith('image')) {
                this.$helper.ShowMessage('error', 'خطأ', 'يرجى اختيار ملف صورة');
                return;
            }
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                if (type === 'insurance') {
                    this.ruleFormVehicle.InsuranceImage = reader.result;
                    this.ruleFormVehicle.InsuranceImageName = file.name;
                } else {
                    this.ruleFormVehicle.InspectionImage = reader.result;
                    this.ruleFormVehicle.InspectionImageName = file.name;
                }
            };
        },
        SetPrimaryVehicle(vehicleId) {
            Swal.fire({
                title: 'تعيين مركبة أساسية',
                text: 'هل تريد تعيين هذه المركبة كمركبة أساسية للسائق؟',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'نعم، تعيين',
                cancelButtonText: 'إلغاء',
                customClass: { confirmButton: 'btn btn-primary', cancelButton: 'btn btn-secondary ms-2' },
                buttonsStyling: false
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();

                    this.$http.SetPrimaryVehicle(vehicleId)
                        .then(() => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم تعيين المركبة كأساسية');
                            this.GetDriverVehicles(this.id); // تحديث جدول المركبات
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage(
                                'error',
                                'خطأ',
                                err?.response?.data ? err.response.data : 'حدث خطأ أثناء تعيين المركبة'
                            );
                        });
                }
            });
        },


         submitVehicle(formRef) {
            const form = this.$refs[formRef];
            if (!form) return;

            form.validate((valid) => {
                if (!valid) return this.$helper.showSwal('warning');

                const body = {
                    Id: null,
                    DriversId: this.id,
                    VehiclesTypesId: this.ruleFormVehicle.VehiclesTypesId,
                    Models: this.ruleFormVehicle.Models,
                    Years: this.ruleFormVehicle.Years,
                    PlateNumber: this.ruleFormVehicle.PlateNumber,
                    SeatsCount: this.ruleFormVehicle.SeatsCount,
                    InsuranceExpiry: this.ruleFormVehicle.InsuranceExpiry || null,
                    InsuranceImage: this.ruleFormVehicle.InsuranceImage || null,
                    InsuranceImageName: this.ruleFormVehicle.InsuranceImageName || null,
                    InspectionExpiry: this.ruleFormVehicle.InspectionExpiry || null,
                    InspectionImage: this.ruleFormVehicle.InspectionImage || null,
                    InspectionImageName: this.ruleFormVehicle.InspectionImageName || null,
                    IsPrimary: this.ruleFormVehicle.IsPrimary
                };
                this.$blockUI.Start();

                this.$http.AddDriverVehicle(body)   // ✅ عدلي الاسم حسب API عندك
                    .then((res) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'عملية ناجحة', res.data);
                        this.ClearForm(this.ruleFormVehicle);
                        this.GetDriverVehicles(this.id);
                        this.$helper.DestroyElemntById('CloseAddVehicle'); // لو عندك زر close بهذا id
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage(
                            'error',
                            'خطأ بعملية الإضافة',
                            err.response && err.response.data ? err.response.data : 'حدث خطأ غير متوقع'
                        );
                    });
            });
        }
        , submitEditVehicle(formRef) {
            const form = this.$refs[formRef];
            if (!form) return;

            form.validate((valid) => {
                if (!valid) return this.$helper.showSwal('warning');

                const body = {
                    Id: Number(this.ruleFormVehicle.Id),
                    DriversId: this.id,
                    VehiclesTypesId: this.ruleFormVehicle.VehiclesTypesId,
                    Models: this.ruleFormVehicle.Models,
                    Years: this.ruleFormVehicle.Years,
                    PlateNumber: this.ruleFormVehicle.PlateNumber,
                    SeatsCount: this.ruleFormVehicle.SeatsCount,
                    InsuranceExpiry: this.ruleFormVehicle.InsuranceExpiry || null,
                    InsuranceImage: this.ruleFormVehicle.InsuranceImage || null,
                    InsuranceImageName: this.ruleFormVehicle.InsuranceImageName || null,
                    InspectionExpiry: this.ruleFormVehicle.InspectionExpiry || null,
                    InspectionImage: this.ruleFormVehicle.InspectionImage || null,
                    InspectionImageName: this.ruleFormVehicle.InspectionImageName || null,
                    IsPrimary: this.ruleFormVehicle.IsPrimary
                };

                this.$blockUI.Start();

                console.log(body);
                this.$http.EditDriverVehicle(body)   // ✅ عدلي الاسم حسب API عندك
                    .then((res) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'عملية ناجحة', res.data);
                        this.ClearForm(this.ruleFormVehicle);
                        this.GetDriverVehicles(this.id);
                        this.$helper.DestroyElemntById('CloseEditVehicle'); // لو حطيتيه
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage(
                            'error',
                            'خطأ بعملية التعديل',
                            err.response && err.response.data ? err.response.data : 'حدث خطأ غير متوقع'
                        );
                    });
            });
        },


        Back() {
            this.Info = '';
            this.state = 0;
            this.GetInfo(this.pageNo);
        },
        //Upload File
        // Backwards-compatible wrapper for the Add modal's first <input>.
        SelectImage(file) {
            return this.SelectDriverImage(file, 'Passport');
        },

        // Generic image picker. `kind` is one of 'Passport' | 'License' | 'Profile'
        // and routes the resulting base64 into the matching ruleForm fields.
        SelectDriverImage(file, kind) {
            if (!file) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى اختيار ملف');
                return;
            }
            if (!file.type || !file.type.startsWith('image/')) {
                this.$helper.ShowMessage('error', 'نوع غير مدعوم', 'الرجاء اختيار صورة');
                return;
            }
            if (file.size > 5 * 1024 * 1024) {
                this.$helper.ShowMessage('error', 'حجم كبير', 'الحجم الأقصى للصورة 5 ميجابايت');
                return;
            }
            const reader = new FileReader();
            reader.onload = () => {
                this.ruleForm[`${kind}Image`] = reader.result;
                this.ruleForm[`${kind}ImageName`] = file.name;
            };
            reader.readAsDataURL(file);
        },
        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) this.pageNo = 1;
            if (!this.Search) this.$blockUI.Start();
            const schoolId = this.loginDetails && this.loginDetails.userType == 40
                ? this.getSchoolId() : null;
            this.$http.GetDrivers(this.pageNo, this.pageSize, this.Search, this.DriverStatus, schoolId)
                .then(response => {
                    if (!this.Search) this.$blockUI.Stop();
                    this.Info = response.data.info || [];
                    this.pages = response.data.count || 0;
                    this.Statistics = response.data.statistics || {};
                })
                .catch(() => {
                    if (!this.Search) this.$blockUI.Stop();
                    this.pages = 0;
                    this.Info = [];
                });
        },

        // Event-based wrappers — used directly from @change in the Edit modal.
        SelectDriverPassportImage(event) {
            const file = event && event.target && event.target.files && event.target.files[0];
            this.SelectDriverImage(file, 'Passport');
        },
        SelectDriverLicenseImage(event) {
            const file = event && event.target && event.target.files && event.target.files[0];
            this.SelectDriverImage(file, 'License');
        },
        SelectDriverProfileImage(event) {
            const file = event && event.target && event.target.files && event.target.files[0];
            this.SelectDriverImage(file, 'Profile');
        },

        // Open a zoomed-in viewer for a document image (passport, license, ...).
        openImageViewer(src, title) {
            if (!src) return;
            this.imageViewer.src = src;
            this.imageViewer.title = title || '';
            this.imageViewer.open = true;
        },

        closeImageViewer() {
            this.imageViewer.open = false;
            this.imageViewer.src = '';
            this.imageViewer.title = '';
        },

        // Format ISO date as DD/MM/YYYY for display.
        formatDate(value) {
            if (!value) return '';
            const d = new Date(value);
            if (Number.isNaN(d.getTime())) return String(value);
            const dd = String(d.getDate()).padStart(2, '0');
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            return `${dd}/${mm}/${d.getFullYear()}`;
        },

        // Toast helper — short non-blocking confirmation in the corner.
        toast(icon, title) {
            Swal.fire({
                toast: true, position: 'top-end', icon, title,
                showConfirmButton: false, timer: 1800, timerProgressBar: true,
            });
        },

        // Force-refresh the table and give the user visual feedback.
        refreshTable() {
            this.GetInfo(this.pageNo);
            this.toast('success', 'تم تحديث البيانات');
        },

        // Build a CSV from the current page rows and trigger a download.
        // Uses UTF-8 BOM so Excel opens Arabic correctly.
        exportToCsv() {
            if (!this.Info || this.Info.length === 0) {
                this.toast('warning', 'لا توجد بيانات للتحميل');
                return;
            }
            const headers = ['#', 'الاسم', 'الهاتف', 'البريد', 'الحالة', 'مفعّل', 'مركبات', 'رحلات'];
            const escape = (v) => {
                if (v === null || v === undefined) return '';
                const s = String(v).replace(/"/g, '""');
                return /[",\n]/.test(s) ? `"${s}"` : s;
            };
            const rows = this.Info.map((item, index) => [
                (this.pageNo - 1) * this.pageSize + index + 1,
                item.name || item.userName || '',
                item.phone || item.userPhone || '',
                item.email || '',
                this.driverStatusLabel ? this.driverStatusLabel(item.driverStatus) : (item.driverStatus || ''),
                item.isActive ? 'نعم' : 'لا',
                item.vehiclesCount ?? '',
                item.tripsCount ?? '',
            ].map(escape).join(','));
            const csv = '﻿' + headers.map(escape).join(',') + '\n' + rows.join('\n');
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            const stamp = new Date().toISOString().slice(0, 10);
            a.download = `drivers-${stamp}.csv`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
            this.toast('success', 'تم تحميل الملف');
        },

        // Open the browser's print dialog with a printer-friendly version
        // of the table only (avoids printing sidebar / header chrome).
        printTable() {
            if (!this.Info || this.Info.length === 0) {
                this.toast('warning', 'لا توجد بيانات للطباعة');
                return;
            }
            const rows = this.Info.map((item, index) => {
                const i = (this.pageNo - 1) * this.pageSize + index + 1;
                const name = item.name || item.userName || '—';
                const phone = item.phone || item.userPhone || '—';
                const status = this.driverStatusLabel ? this.driverStatusLabel(item.driverStatus) : (item.driverStatus || '—');
                const active = item.isActive ? 'نعم' : 'لا';
                return `<tr><td>${i}</td><td>${name}</td><td>${phone}</td><td>${status}</td><td>${active}</td><td>${item.vehiclesCount ?? '—'}</td><td>${item.tripsCount ?? '—'}</td></tr>`;
            }).join('');
            const html = `<!doctype html><html dir="rtl" lang="ar"><head><meta charset="utf-8">
                <title>قائمة السائقين</title>
                <style>
                  body { font-family: 'Tajawal', 'Cairo', Arial, sans-serif; padding: 24px; }
                  h1 { font-size: 18px; margin: 0 0 12px; }
                  .meta { font-size: 12px; color: #555; margin-bottom: 16px; }
                  table { width: 100%; border-collapse: collapse; }
                  th, td { border: 1px solid #ccc; padding: 8px 10px; text-align: right; font-size: 12px; }
                  thead { background: #f3f4f6; }
                </style></head><body>
                <h1>قائمة السائقين — رفيق</h1>
                <div class="meta">تاريخ الطباعة: ${new Date().toLocaleString('en-US')}</div>
                <table><thead><tr>
                  <th>#</th><th>الاسم</th><th>الهاتف</th><th>الحالة</th><th>مفعّل</th><th>مركبات</th><th>رحلات</th>
                </tr></thead><tbody>${rows}</tbody></table>
            </body></html>`;
            const w = window.open('', '_blank', 'width=900,height=700');
            if (!w) {
                this.toast('error', 'الرجاء السماح للنوافذ المنبثقة لطباعة الصفحة');
                return;
            }
            w.document.open();
            w.document.write(html);
            w.document.close();
            w.focus();
            // Defer print so the DOM finishes rendering.
            setTimeout(() => { w.print(); }, 250);
        },

        applyFilters() {
            this.pageNo = 1;
            this.GetInfo(this.pageNo);
        },

        onPageSizeChanged(size) {
            this.pageSize = size;
            this.pageNo = 1;
            this.GetInfo();
        },
        driverStatusLabel(status) {
            if (status === 1) return 'قيد المراجعة';
            if (status === 2) return 'موافق عليه';
            if (status === 3) return 'مرفوض';
            if (status === 9) return 'محذوف';
            return status;
        },

        // ─── الحالة الفعلية للسائق: قيمة واحدة تجيب «ما وضعه الآن؟»
        // الترتيب مقصود ويعكس ما يشعر به السائق فعلاً: حساب موقوف يمنع الدخول
        // فهو يتقدّم على أي حالة اعتماد؛ ثم الرفض؛ ثم قيد المراجعة؛ وأخيراً
        // المعتمَد الذي يبقى أن نقول هل يستقبل رحلات أم لا.
        effectiveStatusLabel(item) {
            if (!item) return '—';
            if (item.userStatus === 3) return 'موقوف الحساب';
            if (item.userStatus === 2) return 'حساب معطّل';
            if (item.driverStatus === 3) return 'مرفوض';
            if (item.driverStatus === 1) return 'قيد المراجعة';
            if (item.driverStatus === 9) return 'محذوف';
            if (item.driverStatus === 2) return item.isActive ? 'معتمَد — يستقبل رحلات' : 'معتمَد — لا يستقبل';
            return this.driverStatusLabel(item.driverStatus);
        },

        effectiveStatusClass(item) {
            if (!item) return 'bg-secondary-subtle text-secondary';
            if (item.userStatus === 3) return 'bg-danger-subtle text-danger';
            if (item.userStatus === 2) return 'bg-secondary-subtle text-secondary';
            if (item.driverStatus === 3) return 'bg-danger-subtle text-danger';
            if (item.driverStatus === 1) return 'bg-warning-subtle text-warning';
            if (item.driverStatus === 9) return 'bg-secondary-subtle text-secondary';
            if (item.driverStatus === 2) return item.isActive
                ? 'bg-success-subtle text-success'
                : 'bg-warning-subtle text-warning';
            return 'bg-secondary-subtle text-secondary';
        },

        // السبب يُعرض فقط حين يفسّر الحالة الظاهرة الآن. سبب رفض قديم لسائق
        // صار معتمَداً لا يُعرض — كان يُبقي كلمة «مرفوض» أمام عين المستخدم
        // بعد زوال الرفض نفسه.
        effectiveStatusReason(item) {
            if (!item) return '';
            if (item.userStatus === 3 && item.suspendReason) return 'سبب الإيقاف: ' + item.suspendReason;
            if (item.driverStatus === 3 && item.rejectReason) return 'سبب الرفض: ' + item.rejectReason;
            return '';
        },

        submitForm(formName) {
            const form = this.$refs[formName];
        
          
            if (!form) return;
            form.validate((valid) => {
                if (valid) {
                    const body = {
                        Id: null,
                        UsersId: this.ruleForm.UsersId || null,
                        FirstName: this.ruleForm.FirstName,
                        FatherName: this.ruleForm.FatherName || null,
                        SirName: this.ruleForm.SirName || null,
                        Phone: this.ruleForm.Phone,
                        PassportExpiry: this.ruleForm.PassportExpiry || null,
                        PassportImage: this.ruleForm.PassportImage || null,
                        PassportImageName: this.ruleForm.PassportImageName || null,
                        LicenseExpiry: this.ruleForm.LicenseExpiry || null,
                        LicenseImage: this.ruleForm.LicenseImage || null,
                        LicenseImageName: this.ruleForm.LicenseImageName || null,
                        ProfileImage: this.ruleForm.ProfileImage || null,
                        ProfileImageName: this.ruleForm.ProfileImageName || null,
                        Descriptions: this.ruleForm.Descriptions || null
                    };
                    this.$blockUI.Start();
                    this.$http.AddDrivers(body)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo(this.pageNo);
                            this.ClearForm(this.ruleForm);
                            this.$helper.DestroyElemntById('CloseAdd');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة', err.response && err.response.data ? err.response.data : 'حدث خطأ غير متوقع');
                        });
                } else {
                    this.$helper.showSwal('warning');
                }
            });
        },

        ViewInfo(item) {
            this.id = item.id;
            this.driverName = item.name;
            this.GetDriverVehicles(this.id);
            this.state = 1;
        },

        GetDriverVehicles(id) {
         this.$blockUI.Start();
            this.$http.GetDriverVehicles(id)
                .then(response => {
                    if (!this.Search) this.$blockUI.Stop();
                    this.Info = response.data.info || [];
                
          
                })
                .catch(() => {
                 this.$blockUI.Stop();
             
                    this.Info = [];
                });
        },

        badgeStatusClass(status) {
            if (status === 1) return 'bg-warning-subtle text-warning';
            if (status === 2) return 'bg-success-subtle text-success';
            if (status === 3) return 'bg-danger-subtle text-danger';
            return 'bg-secondary-subtle text-secondary';
        }
        , 

        async openViewDialog(id) {
            try {
                this.viewLoading = true;
                this.viewError = null;
                this.selectedDriver = null;

                // عدلي المسار حسب راوت مشروعك
                const res = await
                    this.$http.GetDriverById(id)

               

                this.selectedDriver = res.data;
                // «الاشتراك» section — loaded alongside the detail so the admin sees
                // the plan + its end date without another click.
                this.loadDriverSubscriptions(id);
            } catch (err) {

                this.viewError =
                    err?.response?.data?.message ||
                    err?.response?.data ||
                    "حدث خطأ أثناء جلب بيانات السائق";
            } finally {
                this.viewLoading = false;
            }
        },

        // ---- Driver subscriptions (owner step trip-regular-5) ----

        // GET api/admin/Drivers/{id}/Subscriptions. Failures are shown INSIDE the
        // section (never as a page-level error): a school admin opening the same
        // modal simply gets an empty section instead of a broken screen.
        async loadDriverSubscriptions(id) {
            this.resetDriverSubsForm();
            this.driverSubs.loading = true;
            this.driverSubs.error = null;
            this.driverSubs.list = [];
            this.driverSubs.current = null;
            this.driverSubs.hasActive = false;
            this.subsSearch = '';
            try {
                const res = await this.$http.GetDriverSubscriptions(id);
                const d = res.data || {};
                this.driverSubs.list = d.info || [];
                this.driverSubs.current = d.current || null;
                this.driverSubs.hasActive = !!d.hasActiveSubscription;
            } catch (err) {
                this.driverSubs.error =
                    err?.response?.data?.message ||
                    (typeof err?.response?.data === 'string' ? err.response.data : null) ||
                    'تعذّر جلب اشتراكات السائق';
            } finally {
                this.driverSubs.loading = false;
            }
        },

        resetDriverSubsForm() {
            this.driverSubs.showEndForm = false;
            this.driverSubs.endReason = '';
            this.driverSubs.ending = false;
        },

        openEndSubscriptionForm() {
            this.driverSubs.endReason = '';
            this.driverSubs.showEndForm = true;
        },

        // POST api/admin/Drivers/{id}/Subscription/End — the reason is MANDATORY on
        // both sides: it is persisted on the subscription row (DropResone) AND pushed
        // to the driver's app, which is the whole point of the request.
        async submitEndSubscription() {
            const driverId = this.selectedDriver && this.selectedDriver.id;
            if (!driverId) return;

            const reason = (this.driverSubs.endReason || '').trim();
            if (!reason) {
                this.$helper.ShowMessage('error', 'خطأ', 'يرجى كتابة سبب إنهاء الاشتراك — سيظهر للسائق');
                return;
            }
            if (!this.driverSubs.current) {
                this.$helper.ShowMessage('error', 'خطأ', 'لا يوجد اشتراك سارٍ لهذا السائق');
                return;
            }

            const confirmed = await Swal.fire({
                title: 'تأكيد إنهاء الاشتراك',
                text: 'سيتم إنهاء اشتراك السائق فوراً، وفصله عن الاتصال، وإبلاغه بالسبب. هل أنت متأكد؟',
                icon: 'warning',
                showCancelButton: true,
                customClass: { confirmButton: 'btn btn-danger', cancelButton: 'btn btn-label-secondary' },
                buttonsStyling: false,
                confirmButtonText: 'نعم، إنهاء الاشتراك',
                cancelButtonText: 'تراجع'
            });
            if (!confirmed.isConfirmed) return;

            this.driverSubs.ending = true;
            this.$blockUI.Start();
            try {
                await this.$http.EndDriverSubscription(driverId, {
                    Reason: reason,
                    SubscriptionId: this.driverSubs.current.id
                });
                this.$blockUI.Stop();
                this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم إنهاء الاشتراك وإبلاغ السائق بالسبب');
                this.resetDriverSubsForm();
                await this.loadDriverSubscriptions(driverId);
                // The driver row itself changed (IsActive/IsSubscribed) — refresh the list.
                this.GetInfo(this.pageNo);
            } catch (err) {
                this.$blockUI.Stop();
                this.driverSubs.ending = false;
                this.$helper.ShowMessage('error', 'خطأ',
                    err?.response?.data?.message ||
                    (typeof err?.response?.data === 'string' ? err.response.data : null) ||
                    'تعذّر إنهاء الاشتراك');
            }
        },

        subscriptionBadgeClass(sub) {
            if (!sub) return 'bg-secondary-subtle text-secondary';
            if (sub.isActive) return 'bg-success-subtle text-success';
            if (sub.status === 3 || sub.status === 4) return 'bg-danger-subtle text-danger';
            return 'bg-secondary-subtle text-secondary';
        },

        subscriptionStateLabel(sub) {
            if (!sub) return '—';
            if (sub.isActive) return 'سارٍ';
            if (sub.status === 3) return 'مُنهى من الإدارة';
            if (sub.status === 4) return 'منسحب';
            return 'منتهٍ';
        },

        // Local date formatter — HelperMixin has none, and the subscription section
        // must not render raw ISO timestamps to the admin.
        fmtDate(value) {
            if (!value) return '—';
            const d = new Date(value);
            if (isNaN(d.getTime())) return value;
            const pad = (n) => String(n).padStart(2, '0');
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
        },

        async OpentEditDialog(item) {
            this.SelectedItem = item;
            // Pre-fill from the list row immediately so the modal renders
            // without a blank flash.
            const apply = (src) => {
                this.ruleForm.Id = src.id;
                this.ruleForm.UsersId = src.usersId || null;
                this.ruleForm.FirstName = src.firstName || (src.name ? src.name.split(' ')[0] : '');
                this.ruleForm.FatherName = src.fatherName || '';
                this.ruleForm.SirName = src.sirName || '';
                this.ruleForm.Phone = src.phone || '';
                this.ruleForm.PassportExpiry = src.passportExpiry || null;
                this.ruleForm.PassportImage = src.passportImage || '';
                this.ruleForm.PassportImageName = '';
                this.ruleForm.LicenseExpiry = src.licenseExpiry || null;
                this.ruleForm.LicenseImage = src.licenseImage || '';
                this.ruleForm.LicenseImageName = '';
                this.ruleForm.ProfileImage = src.profileImage || src.image || '';
                this.ruleForm.ProfileImageName = '';
                this.ruleForm.Descriptions = src.descriptions || '';
            };
            apply(item);

            // The /Get list endpoint trims its payload — it does NOT include
            // image URLs. Pull the full detail via GetDriverById so previews
            // of existing passport/license/profile images can render.
            try {
                const res = await this.$http.GetDriverById(item.id);
                if (res && res.data) apply(res.data);
            } catch (e) {
                // Best-effort: keep the list-row values if the detail call fails.
            }
        },

        SelectPassportImage(file) {
            if (!file) return;
            if (file.type.substring(0, 5) !== 'image') {
                this.$helper.ShowMessage('error', 'خطأ', 'اختر صورة');
                return;
            }
            const $this = this;
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                $this.ruleForm.PassportImageName = file.name;
                $this.ruleForm.PassportImage = reader.result;
            };
        },

        submitEditForm(formName) {
            const form = this.$refs[formName];
            if (!form) return;
            form.validate((valid) => {
                if (valid) {
                    const body = {
                        Id: Number(this.ruleForm.Id),
                        UsersId: this.ruleForm.UsersId || null,
                        FirstName: this.ruleForm.FirstName,
                        FatherName: this.ruleForm.FatherName || null,
                        SirName: this.ruleForm.SirName || null,
                        Phone: this.ruleForm.Phone,
                        PassportExpiry: this.ruleForm.PassportExpiry || null,
                        PassportImage: this.ruleForm.PassportImage || null,
                        PassportImageName: this.ruleForm.PassportImageName || null,
                        LicenseExpiry: this.ruleForm.LicenseExpiry || null,
                        LicenseImage: this.ruleForm.LicenseImage || null,
                        LicenseImageName: this.ruleForm.LicenseImageName || null,
                        ProfileImage: this.ruleForm.ProfileImage || null,
                        ProfileImageName: this.ruleForm.ProfileImageName || null,
                        Descriptions: this.ruleForm.Descriptions || null
                    };
                    this.$blockUI.Start();
                    this.$http.EditDrivers(body)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo(this.pageNo);
                            this.ClearForm(this.ruleForm);
                            this.$helper.DestroyElemntById('CloseEdit');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response && err.response.data ? err.response.data : 'حدث خطأ غير متوقع');
                        });
                } else {
                    this.$helper.showSwal('warning');
                }
            });
        },

        Approve(Id) {
            this.confirmPopup({ title: 'تأكيد الموافقة', text: 'هل أنت متأكد من الموافقة على السائق؟' })
                .then((ok) => {
                    if (ok) {
                        this.$blockUI.Start();
                        this.$http.ApproveDriver(Id)
                            .then(() => { this.$blockUI.Stop(); this.$helper.ShowMessage('success', 'عملية ناجحة', 'تمت الموافقة'); this.GetInfo(this.pageNo); })
                            .catch((err) => { this.$blockUI.Stop(); this.$helper.ShowMessage('error', 'خطأ', err.response && err.response.data ? err.response.data : 'حدث خطأ'); });
                    }
                });
        },

        // الرفض له وجهان يعتمدان على حالة السائق، والعنوان يقولهما صراحة:
        //   • قيد المراجعة ← «رفض طلب الانضمام».
        //   • معتمَد ← «سحب الاعتماد» — هكذا يستخدمه المالك فعلاً (الخادم يحوّله
        //     إلى مرفوض ويُسجّل خروجه فوراً).
        // وكلاهما غير «إيقاف الحساب» المؤقت لسائق يبقى معتمَداً.
        // السبب إلزامي لأنه يُعرض للسائق نفسه في التطبيق (Drivers.RejectReason).
        Reject(item) {
            const id = typeof item === 'object' && item !== null ? item.id : item;
            const isApproved = typeof item === 'object' && item !== null && item.driverStatus === 2;
            this.reasonPopup({
                title: isApproved ? 'سحب اعتماد السائق' : 'رفض طلب الانضمام',
                html: (isApproved
                        ? 'سيتحوّل السائق إلى «مرفوض» ويُسجَّل خروجه فوراً ولن يستطيع العمل.'
                        : 'لن يُعتمد هذا السائق ولن يستطيع العمل.') +
                      '<br><small class="text-muted">هذا غير «إيقاف الحساب» المؤقت — الإيقاف يُبقيه معتمَداً ويمنعه من الدخول فقط.</small>',
                icon: 'warning',
                inputLabel: 'السبب (إلزامي — يظهر للسائق في تطبيقه)',
                inputPlaceholder: isApproved ? 'مثال: مخالفات متكررة بعد التحذير' : 'مثال: صورة رخصة القيادة غير واضحة',
                confirmButtonText: isApproved ? 'سحب الاعتماد' : 'رفض الطلب'
            }).then((reason) => {
                if (!reason) return;
                this.$blockUI.Start();
                this.$http.RejectDriver(id, reason)
                    .then(() => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'تم', 'أُبلغ السائق بالسبب');
                        this.GetInfo(this.pageNo);
                    })
                    .catch((err) => { this.$blockUI.Stop(); this.$helper.ShowMessage('error', 'خطأ', err.response && err.response.data ? err.response.data : 'حدث خطأ'); });
            });
        },

        ApproveVehicle(Id) {
            this.confirmPopup({ title: 'تأكيد الموافقة', text: 'هل أنت متأكد من الموافقة على  مركبة السائق؟' })
                .then((ok) => {
                    if (ok) {
                        this.$blockUI.Start();
                        this.$http.ApproveDriverVehicle(Id)
                            .then(() => { this.$blockUI.Stop(); this.$helper.ShowMessage('success', 'عملية ناجحة', 'تمت الموافقة'); this.GetDriverVehicles(this.id); })
                            .catch((err) => { this.$blockUI.Stop(); this.$helper.ShowMessage('error', 'خطأ', err.response && err.response.data ? err.response.data : 'حدث خطأ'); });
                    }
                });
        },

        RejectVehicle(Id) {
            this.confirmPopup({ title: 'تأكيد الرفض', text: 'هل أنت متأكد من رفض  مركبة السائق؟' })
                .then((ok) => {
                    if (ok) {
                        this.$blockUI.Start();
                        this.$http.RejectDriverVehicle(Id)
                            .then(() => { this.$blockUI.Stop(); this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم الرفض'); this.GetDriverVehicles(this.id); })
                            .catch((err) => { this.$blockUI.Stop(); this.$helper.ShowMessage('error', 'خطأ', err.response && err.response.data ? err.response.data : 'حدث خطأ'); });
                    }
                });
        },
        ChangeActive(Id) {
            this.$blockUI.Start();
            this.$http.ChangeActiveDriver(Id)
                .then(() => { this.$blockUI.Stop(); this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم تغيير الحالة'); this.GetInfo(this.pageNo); })
                .catch((err) => { this.$blockUI.Stop(); this.$helper.ShowMessage('error', 'خطأ', err.response && err.response.data ? err.response.data : 'حدث خطأ'); });
        },

        openSuspendModal(Id) {
            this.SuspendDriverId = Id;
            this.SuspendReason = '';
        },

        submitSuspend() {
            if (!this.SuspendReason || !this.SuspendDriverId) {
                this.$helper.ShowMessage('error', 'خطأ', 'يرجى إدخال سبب إيقاف الحساب');
                return;
            }
            this.$blockUI.Start();
            this.$http.SuspendDriver({ DriverId: this.SuspendDriverId, Reason: this.SuspendReason })
                .then(() => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم إيقاف حساب السائق');
                    this.SuspendDriverId = null;
                    this.SuspendReason = '';
                    this.$helper.DestroyElemntById('CloseSuspend');
                    this.GetInfo(this.pageNo);
                })
                .catch((err) => { this.$blockUI.Stop(); this.$helper.ShowMessage('error', 'خطأ', err.response && err.response.data ? err.response.data : 'حدث خطأ'); });
        },

        CancelSuspend(Id) {
            this.confirmPopup({ title: 'رفع إيقاف الحساب', text: 'هل أنت متأكد من رفع الإيقاف عن حساب السائق؟' })
                .then((ok) => {
                    if (ok) {
                        this.$blockUI.Start();
                        this.$http.CancelSuspendDriver(Id)
                            .then(() => { this.$blockUI.Stop(); this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم رفع إيقاف الحساب'); this.GetInfo(this.pageNo); })
                            .catch((err) => { this.$blockUI.Stop(); this.$helper.ShowMessage('error', 'خطأ', err.response && err.response.data ? err.response.data : 'حدث خطأ'); });
                    }
                });
        },


        DeleteVehicle(Id) {
            this.confirmPopup({ title: 'تأكيد الحذف', text: 'هل أنت متأكد من حذف  مركبة السائق؟' })
                .then((ok) => {
                    if (ok) {
                        this.$blockUI.Start();
                        this.$http.DeleteDriverVehicle(Id)
                            .then(() => { this.$blockUI.Stop(); this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم الحذف'); this.GetDriverVehicles(this.id); })
                            .catch((err) => { this.$blockUI.Stop(); this.$helper.ShowMessage('error', 'خطأ', err.response && err.response.data ? err.response.data : 'حدث خطأ'); });
                    }
                });
        },



        Delete(Id) {
            this.confirmPopup({ title: 'تأكيد الحذف', text: 'هل أنت متأكد من حذف السائق؟' })
                .then((ok) => {
                    if (ok) {
                        this.$blockUI.Start();
                        this.$http.DeleteDrivers(Id)
                            .then(() => { this.$blockUI.Stop(); this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم الحذف'); this.GetInfo(this.pageNo); })
                            .catch((err) => { this.$blockUI.Stop(); this.$helper.ShowMessage('error', 'خطأ', err.response && err.response.data ? err.response.data : 'حدث خطأ'); });
                    }
                });
        },

        // Audit P1 #8: unlink the driver from the current school-admin's school.
        unlinkFromSchool(item) {
            const schoolId = this.getSchoolId ? this.getSchoolId() : null;
            if (!schoolId) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'تعذّر تحديد المدرسة الحالية.');
                return;
            }
            Swal.fire({
                title: 'إلغاء السائق من المدرسة',
                text: 'هل أنت متأكد من فك ارتباط هذا السائق بالمدرسة؟',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'نعم، إلغاء الربط',
                cancelButtonText: 'إلغاء'
            }).then((result) => {
                if (!result.isConfirmed) return;
                this.$blockUI.Start();
                this.$http.RemoveDriverFromSchool(item.id, schoolId)
                    .then((res) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'عملية ناجحة', res.data || 'تم فك ارتباط السائق بالمدرسة');
                        this.GetInfo(this.pageNo);
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ', err.response && err.response.data ? err.response.data : 'حدث خطأ');
                    });
            });
        }
    }
};
